import HomeHeader from "modules/home-header"
import { useAccountAlias, useIsAiTermsAccepted, useIsAiChatFeatureEnabled, useIsManagedAgentEnabled } from "resources/account"
import AiTeammateWithButtonToggle from "connected-components/ai-teammate/components/ai-toggle-button"
import { useAppSelector } from "hooks/redux"
import { useCurrentDashboardId } from "./context/current-dashboard-id"
import { DEFAULT_CORE_STATE } from "./store/core-slice"
import { selectModelId } from "./store/selectors/select-model-id"
import DashboardSwitcher from "./components/switcher/dashboard-switcher"

export default function DashboardHeader() {
  const accountAlias = useAccountAlias()
  const dashboardId = useCurrentDashboardId()
  const instrument = useAppSelector((s) => (dashboardId === null ? null : s.dashboard.core[dashboardId]?.instrument) ?? DEFAULT_CORE_STATE.instrument)
  const modelId = useAppSelector((s) => selectModelId(s, dashboardId))
  const isAiTermsAccepted = useIsAiTermsAccepted()
  const isAiChatFeatureEnabled = useIsAiChatFeatureEnabled()
  // Managed-agent accounts use Kelly chat instead of the legacy drawer.
  const isManagedAgentEnabled = useIsManagedAgentEnabled()

  const canOpenAiDrawer = !isManagedAgentEnabled && isAiTermsAccepted && isAiChatFeatureEnabled && !!instrument && !!modelId

  // No icon/title: the active dashboard tab names the workspace, so the switcher fills the bar.
  // The instrument is per-instance, so its selector lives in the in-canvas top bar (DashboardTopBar),
  // not this global header chrome.
  return (
    <HomeHeader account={accountAlias} className="dashboard-header" modelId={modelId}>
      <DashboardSwitcher />
      {canOpenAiDrawer && <AiTeammateWithButtonToggle key={dashboardId} />}
    </HomeHeader>
  )
}
